import type { ResumeTypes } from "@/types";

export const educationData: ResumeTypes.EducationItem[] = [
	{
		date: {
			start: "2020",
			end: "2020",
		},
		degree: "Python Programming",
		school: "General Assembly",
		description:
			"I completed a 12-week intensive program focused on Python programming, covering topics such as data structures, algorithms, and web development. This program provided me with a strong foundation in programming and a deeper understanding of Python's capabilities.",
	},
];
